var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8396 9.62345L9.36624 15.4168C9.15958 15.6368 8.95958 16.0701 8.91958 16.3701L8.67291 18.5301C8.58624 19.3101 9.14624 19.8435 9.91958 19.7101L12.0662 19.3435C12.3662 19.2901 12.7862 19.0701 12.9929 18.8435L18.4662 13.0501C19.4129 12.0501 19.8396 10.9101 18.3662 9.51679C16.8996 8.13679 15.7862 8.62345 14.8396 9.62345Z",
    stroke: "#004EFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9297 10.5938C14.2164 12.4338 15.7097 13.8404 17.563 14.0271",
    stroke: "#004EFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/EditIcon.f503c1950697c77b13648ad34e423d3c.svg";
export { ForwardRef as ReactComponent };